import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const ModalOverlay = styled.div`
  width: 100%;
  height: 100%;

  position: fixed;

  top: 0;
  left: 0;

  background: ${DIGIPOSTHEME.colors.primaryBlack};
  opacity: 0.4;

  z-index: 1001;
`;

export const ModalHeader = styled.div<{ isIcon: boolean }>`
  height: ${({ isIcon }) => (isIcon ? `68px` : `56px`)};

  display: flex;
  justify-content: space-between;
  align-items: center;

  pointer-events: all;

  padding: 0 15px;

  background-color: ${DIGIPOSTHEME.colors.secondaryGrey};

  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;

  font-family: "Campton";
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.23px;
  color: ${DIGIPOSTHEME.colors.secondaryBlack};

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 16px;
  }
`;

export const TitleText = styled.div`
  margin-top: 3px;

  font-weight: 500;
  letter-spacing: 0.23px;
`;

export const CloseButtonArea = styled.div<{ isIcon: boolean }>`
  display: flex;

  margin: ${({ isIcon }) => (isIcon ? `0` : `16px 0 8px 0`)};
`;
export const ModalInformationField = styled.div<{ isIcon: boolean }>`
  padding: ${({ isIcon }) =>
    isIcon ? `21px 12px 22px 22px` : `0 20px 0 20px`};
  margin-bottom: 24px;

  font-family: "Campton";
  line-height: 1.33;
  font-size: 18px;
  letter-spacing: ${({ isIcon }) => (isIcon ? `0` : `0.23px`)};
  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
  text-align: center;

  ${({ isIcon }) => isIcon && `border-bottom: 1px solid #e6e6e6`};

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 0;

    font-size: 14px;
    letter-spacing: 0;
  }
`;

export const OuterContainer = styled.div<{
  maxWidth?: number;
  boxShadow?: string;
}>`
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : `max-content`)};

  position: fixed;
  left: 50%;
  top: calc(10vh + 40%);
  transform: translate(-50%, -50%);

  border-radius: 8px;

  background: white;
  box-shadow: ${({ boxShadow }) => boxShadow && boxShadow};

  z-index: 1002;

  & > :last-child {
    max-height: 75vh;
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 90%;
    min-width: auto;
    top: calc(0vh + 50%);
    /*min-height: 405px; */
  }
`;

export const ModalBodyContainer = styled.div`
  max-height: 72vh;

  padding: 1px;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  @media ${MEDIA_QUERIES.MOBILE} {
    max-height: 64vh;
  }
`;

export const ModalBody = styled.div`
  padding: 24px 0;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 24px 15px;

    overflow-x: hidden;
  }
`;
